import { NavLink } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import Load from "../../common/Loader/Load";
import "./Agreements.css";

const Agreements = ({ hotels }) => {
  if (!hotels || hotels.length === 0) {
    return <Load />;
  }

  return (
    <article className="agreements">
      <h1 className="agreements__title">Convenios</h1>

      <section className="agreements__carousel">
        <Swiper
          modules={[Navigation]}
          loop={hotels.length > 3}
          centeredSlides={false}
          grabCursor={true}
          navigation={true}
          spaceBetween={20}
          slidesPerView={2.5}
          breakpoints={{
            0: {
              slidesPerView: 1.5,
            },
            640: {
              slidesPerView: 2.5,
            },
            1024: {
              slidesPerView: 2.5,
            },
          }}
          className="agreements__swiper"
        >
          {hotels.map((hotel) => (
            <SwiperSlide key={hotel.id} className="agreements__slide">
              <NavLink
                to={`/Solicitar/${hotel.id}/${hotel.titulo}`}
                className="agreement-card"
              >
                <img
                  src={hotel.portada}
                  alt={hotel.titulo}
                  className="agreement-card__image"
                />

                <div className="agreement-card__info">
                  <span className="agreement-card__name">{hotel.titulo}</span>

                  <span className="agreement-card__city">{hotel.ciudad}</span>
                </div>
              </NavLink>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    </article>
  );
};

export default Agreements;
